const Ajax = require('common/infra/ajax');

module.exports = class API {
    /**
     * Actionの一括作成リクエストを登録する
     *
     * @param actionKey
     * @param contentVersionKey
     * @returns {*}
     */
    import(actionKey, contentVersionKey) {
        const path = `/api/projects/${actionKey.parent.id}/actions/${actionKey.id}/import_requests`;
        const json = {
            contentID: contentVersionKey.parent.id,
            contentVersionID: contentVersionKey.id
        };

        return Ajax.POST(path, json)
            .then(data => {
                return data;
            });
    }

    /**
     * Actionの一括登録リクエストの内容を取得する
     *
     * @param actionKey
     * @param importRequestId
     * @returns {*}
     */
    get(actionKey, importRequestId) {
        const path = `/api/projects/${actionKey.parent.id}/actions/${actionKey.id}/import_requests/${importRequestId}`;

        return Ajax.GET(path)
            .then(data => {
                return data;
            });
    }

    /**
     * Actionの一括登録リクエストの内容をプレビューする
     *
     * @param actionKey
     * @param importRequestId
     * @returns {*}
     */
    preview(actionKey, importRequestId) {
        const path = `/api/projects/${actionKey.parent.id}/actions/${actionKey.id}/import_requests/${importRequestId}/preview`;

        return Ajax.GET(path)
            .then(data => {
                return data;
            });
    }

    /**
     * Actionの一括登録リクエストの内容から、実際にアクションを作成する
     *
     * @param actionKey
     * @param importRequestId
     * @return {*|Promise<T | never>}
     */
    execute(actionKey, importRequestId) {
        const path = `/api/projects/${actionKey.parent.id}/actions/${actionKey.id}/import_requests/${importRequestId}/execute`;

        return Ajax.POST(path)
            .then(data => {
                return data;
            });
    }
};




// WEBPACK FOOTER //
// ./balus/infra/api/action/import.js